import { Validator } from '@vista-digital/validator';
/**
 * Default config for **Item Picker** component buttons.
 */
export const defaultItemPickerItemButtonConfig = {
    disabled: false,
    showDescription: true,
    showPrice: true,
    showPromotionLabel: true
};
export const itemPickerItemButtonConfigValidator = Validator.object({
    disabled: Validator.boolean(),
    showDescription: Validator.boolean(),
    showPrice: Validator.boolean(),
    showPromotionLabel: Validator.boolean()
});
